import * as a from "@tinymce/tinymce-react"

export const tinyMCE:any = a;
export const Editor:any = a.Editor;
